"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const handleError = (error) => {
    (0, pixel_pigeon_1.emitToSocketioServer)({
        data: {
            message: error.message,
            stack: typeof error.stack !== "undefined" ? error.stack : null,
        },
        event: "screen-error",
    });
};
exports.handleError = handleError;
